var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('video',{attrs:{"src":require("./assets/video/bg.mp4"),"autoplay":"","muted":"","loop":""},domProps:{"muted":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }